import styled from "styled-components";

export const Steps = styled.div`
  background-color: var(--lightGray);
  color: var(--darkGray);
  font-size: 13px;
  padding: 5px 20px;
  border-radius: 10px;
  font-weight: bold;
`